var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewBooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10H13ZM11 21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21H11ZM12.8787 18.8787L12.1716 18.1716L12.1716 18.1716L12.8787 18.8787ZM20 18V19C20.5523 19 21 18.5523 21 18H20ZM21 11V10H19V11H21ZM11 10V21H13V10H11ZM13 21C13 20.4696 13.2107 19.9609 13.5858 19.5858L12.1716 18.1716C11.4214 18.9217 11 19.9391 11 21H13ZM13.5858 19.5858C13.9609 19.2107 14.4696 19 15 19V17C13.9391 17 12.9217 17.4214 12.1716 18.1716L13.5858 19.5858ZM15 19H20V17H15V19ZM21 18V11H19V18H21Z",
    fill: "#392118"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4V3C3.44772 3 3 3.44772 3 4H4ZM12 8H13H12ZM11 21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21H11ZM9 18V17V18ZM4 18H3C3 18.5523 3.44772 19 4 19V18ZM4 5H8V3H4V5ZM8 5C8.79565 5 9.55871 5.31607 10.1213 5.87868L11.5355 4.46447C10.5979 3.52678 9.32608 3 8 3V5ZM10.1213 5.87868C10.6839 6.44129 11 7.20435 11 8H13C13 6.67392 12.4732 5.40215 11.5355 4.46447L10.1213 5.87868ZM11 8V21H13V8H11ZM13 21C13 19.9391 12.5786 18.9217 11.8284 18.1716L10.4142 19.5858C10.7893 19.9609 11 20.4696 11 21H13ZM11.8284 18.1716C11.0783 17.4214 10.0609 17 9 17V19C9.53043 19 10.0391 19.2107 10.4142 19.5858L11.8284 18.1716ZM9 17H4V19H9V17ZM5 18V4H3V18H5Z",
    fill: "#392118"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 1V4M20 4V7M20 4H23M20 4H17",
    stroke: "#392118",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBooking);
export default __webpack_public_path__ + "static/media/new-booking.68713f67e111f769b0232571542a628d.svg";
export { ForwardRef as ReactComponent };